"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var prop_types_1 = require("prop-types");
var react_1 = __importDefault(require("react"));
var Typography = function (_a) {
    var element = _a.element, type = _a.type, className = _a.className, margins = _a.margins, other = __rest(_a, ["element", "type", "className", "margins"]);
    var T = element;
    return (react_1.default.createElement(T, __assign({ className: classnames_1.default("mdc-typography--" + type, { "mdc-typography--no-margins": !margins }, className) }, other)));
};
Typography.propTypes = {
    /** Custom CSS class */
    className: prop_types_1.string,
    /** The element type to render (h1, h2, etc.) */
    element: prop_types_1.string,
    /** Remove margins */
    margins: prop_types_1.bool,
    /** The MDC type  */
    type: prop_types_1.oneOf([
        "headline1",
        "headline2",
        "headline3",
        "headline4",
        "headline5",
        "headline6",
        "subtitle1",
        "subtitle2",
        "body1",
        "body2",
        "caption",
        "button",
        "overline",
    ]),
};
Typography.defaultProps = {
    element: "div",
    margins: false,
    type: "body1",
};
exports.default = Typography;
//# sourceMappingURL=Typography.js.map